import { IFunnelRepository } from '../../../domain/repositories/IFunnelRepository';
import { Funnel } from '../../../types';

export class CreateFunnelUseCase {
    constructor(private funnelRepository: IFunnelRepository) { }

    async execute(name: string, organizationId?: string): Promise<Funnel> {
        // ID temporário, será substituído pelo banco
        const funnel: Funnel = { id: `temp_${Date.now()}`, name };
        return this.funnelRepository.save(funnel, organizationId);
    }
}
